import React, { useEffect, useState, useMemo, useRef } from 'react'
import { Link, useParams, useLocation } from 'react-router-dom'
import { getSkuPriceData, resolveDiscount } from "../helper/discount";
import { ToastContainer, toast } from 'react-toastify';
import { addToCart, addToWishlist } from "../action"
import { useDispatch, useSelector } from "react-redux";
import Header from "../component/Header";
import Footer from "../component/Footer";
import ReactImageZoom from "react-image-zoom";
import ReactImageMagnify from 'react-image-magnify';
import $ from 'jquery';
import axios from "../helper/axios";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import RelatedProduct from './RelatedProduct';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'react-toastify/dist/ReactToastify.css';
import './Productfilter.css';
import Summary from './Summary';
import ProductImages from './ProductImages';
import ValidationError from './Common/ValidationError';
import WishlistHeartIcon from "./Common/WishlistHeartIcon";
import { trackAddToCart } from "../helper/analyticsConsent";
import { trackViewContent } from "../helper/analyticsConsent";
import { subBrandFromProductBrand } from "../helper/filterOptions";

export default function ProductDetails() {

  const { id, catId } = useParams();
  const location = useLocation();
  const RelatePrd = useMemo(() => <RelatedProduct catId={catId} />, [catId]);
  const notify = (msg) => toast.warning(msg);
  const displayWidth = window.innerWidth;
  const dispayHeight = window.innerHeight;
  const [qty, setQty] = useState(1);
  const [singleProductData, setSingleProductData] = useState([]);
  const [prodDetails, setProdDetails] = useState([]);
  const dispatch = useDispatch();
  const productData = useSelector(state => state?.productData?.allProduct)
  const genderData = useSelector(state => state?.category?.gender)
  const dataDetails = productData.find(dt => dt._id === id)
  const [variantClickData, setVariantClickData] = useState([])
  const [allVariantData, setAllVariantData] = useState([])
  const cartData = useSelector(state => state.cart?.cartItems);
  const [selectedSize, setSelectedSize] = useState();
  const [selectedColor, setSelectedColor] = useState();
  const [clicking, setClicking] = useState();
  const [maxnumber, setmaxnumber] = useState(1);
  const [cartPopup, setCartPopup] = useState(false)
  const [isAlertVisible, setIsAlertVisible] = React.useState(false);
  const [prices, setPrices] = React.useState();
  const [skuData, setSkuData] = React.useState();
  const [stockQuantity, setStockQuantity] = React.useState(0);
  const [showZoom, setShowZoom] = useState(false)
  const [index, setIndex] = useState(0);
  const [storeInfo, setStoreInfo] = useState();
  const [storeOptions, setStoreOptions] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const wishlistItems = useSelector(state => state?.cart?.wishlistItems);
  const [errorMessage, setErrorMessage] = useState(''); 
  const [errorTrigger, setErrorTrigger] = useState(0);
  const viewContentTrackedRef = useRef(new Set());

  useEffect(() => {
    if (wishlistItems && wishlistItems.length > 0) {
      const isFound = wishlistItems.some((x) => x?._id === prodDetails?._id);
      setIndex(isFound ? 1 : 0);
    } else {
      setIndex(0);
    }
  }, [wishlistItems, prodDetails]);


  useEffect(() => {
    fetchProductData();
    $(document).ready(function () {
      $(".productthumb div img:first").addClass("firstimg");
    });
    
    // Always scroll to top when opening product details
        window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
        });
    
    localStorage.setItem("prevUrl", window.location.href);
    
    // Reset state when product changes
    setVariantClickData([]);
    setSelectedColor(null);
    setSelectedSize(null);
    setSelectedLocation(null);
    setStoreOptions([]);
    setQty(1);
    setPrices(null);
    setStockQuantity(0);
    setErrorMessage("");
  }, [id, location.pathname])

  useEffect(() => {
    // Track ViewContent once per product id (after data loads)
    if (!prodDetails?._id && !id) return;
    if (!prodDetails?.name) return;

    const key = String(prodDetails?.externalId || prodDetails?._id || id);
    if (viewContentTrackedRef.current.has(key)) return;

    viewContentTrackedRef.current.add(key);

    const sku = variantClickData?.productInfo?.selectedSkus?.skuId || prices?.skuId;
    const price = sku ? findPrice(variantClickData?.productInfo?.selectedSkus || prices) : findPrice(prices);

    try {
      trackViewContent({
        productId: prodDetails?.externalId || id,
        sku,
        name: prodDetails?.name,
        category: prodDetails?.categories?.[0] || prodDetails?.category,
        price,
      });
    } catch (e) {
      // ignore tracking errors
    }
  }, [id, prodDetails, prices, variantClickData]);

   
  function PriceDisplay(prices) {
    // Don't display price if prices is null/undefined
    if (!prices) {
      return null;
    }

    const { regular, sale, sale2, hasDiscount, hasDiscount2 } = resolveDiscount(getSkuPriceData(prices));

    return (
      <p className="text-md font-bold py-2 f-16 single-prod-price">
        {hasDiscount2 ? (
          <>
            <del>{regular.toFixed(2)} €</del>
            <del className="mx-1">{sale.toFixed(2)} €</del>
            <span className="regular salening"> {sale2.toFixed(2)} €</span>
          </>
        ) : hasDiscount ? (
          <>
            <del>{regular.toFixed(2)} €</del>
            <span className="regular salening"> {sale.toFixed(2)} €</span>
          </>
        ) : (
          regular > 0 && <h4 className="regular">{regular.toFixed(2)} €</h4>
        )}
      </p>
    );
  }


  function findPrice(prices) {
    return resolveDiscount(getSkuPriceData(prices)).activePrice;

    // return (
    //   <p className="text-md font-bold py-2 f-16 single-prod-price">
    //     {isDiscountActive ? (
    //       <>
    //         <del>{Number(prices?.price || 0).toFixed(2)} €</del>
    //         <span className="regular salening"> {Number(prices?.discountPrice).toFixed(2)} €</span>
    //       </>
    //     ) : (
    //       prices?.price > 0 && <h4 className="regular">{Number(prices?.price).toFixed(2)} €</h4>
    //     )}
    //   </p>
    // );
  }


  const addItemToWishlist = async (res) => {
    setClicking(Math.random());

    if (res?.externalId) {
      // create a new array to avoid mutating redux state directly
      const newWishlist = wishlistItems ? [...wishlistItems] : [];
      const idx = newWishlist.findIndex(x => x?._id === res?._id);
      if (idx === -1) {
        newWishlist.push(res);
        setIndex(1);
      } else {
        newWishlist.splice(idx, 1);
        setIndex(0);
      }
      dispatch(addToWishlist(newWishlist));

    } else {
      // ensure we don't mutate the original wishlist array
      const newWishlist = wishlistItems ? [...wishlistItems] : [];
      const idToUse = res?._id || res;
      const idx = newWishlist.findIndex(x => x?._id === idToUse?._id);
      if (idx === -1) {
        newWishlist.push(idToUse);
        setIndex(1);
      } else {
        newWishlist.splice(idx, 1);
        setIndex(0);
      }
      dispatch(addToWishlist(newWishlist));
    }

  }

  const getFirstInStockSku = (variant) => {
    const sizes = variant?.sizes || [];
    for (const s of sizes) {
      const skus = s?.skus || [];
      const sku = skus.find(sk => Number(sk?.quantity || 0) > 0);
      if (sku) return sku;
    }
    return null;
  };

  // Price should still show even when out of stock
  const getFirstSku = (variant) => {
    const sizes = variant?.sizes || [];
    for (const s of sizes) {
      const sku = s?.skus?.[0];
      if (sku) return sku;
    }
    return null;
  };

  const getDefaultPriceSku = (variants = []) => {
    for (const v of variants) {
      const inStock = getFirstInStockSku(v);
      if (inStock) return inStock;
    }
    for (const v of variants) {
      const anySku = getFirstSku(v);
      if (anySku) return anySku;
    }
    return null;
  };

  const applyStoreProduct = (entry) => {
    if (!entry) return;

    const productDetails = entry.productDetails;
    setStoreInfo(entry.storeInfo);
    setSelectedLocation(productDetails?.location || entry.location || null);
    setProdDetails(productDetails);
    setAllVariantData(productDetails?.variants || []);
    setVariantClickData([]);
    setSelectedColor(null);
    setSelectedSize(null);
    setQty(1);
    setStockQuantity(0);
    setErrorMessage("");

    const variants = productDetails?.variants || [];
    setPrices(getDefaultPriceSku(variants));

    if (variants.length === 1 && variants[0]?.colour) {
      applyColorSelection(variants[0].colour, productDetails);
    }
  };

  const fetchProductData = async () => {
    const dataId = { _id: id };
    const res = await axios.post("/getproductbyid", dataId);

    if (res?.data?.length > 0) {
      setSingleProductData(res.data);
      setStoreOptions(res.data);

      // One store in DB → select by default. Multiple → user picks first.
      if (res.data.length === 1) {
        applyStoreProduct(res.data[0]);
      } else {
        setStoreInfo(null);
        setSelectedLocation(null);
        const firstDetails = res.data[0]?.productDetails || [];
        setProdDetails(firstDetails);
        setAllVariantData([]);
        // Show default price even before store is chosen / even if OOS
        setPrices(getDefaultPriceSku(firstDetails?.variants || []));
      }
    }
  }

  const onQuantityIncrement = () => {
    // Get current stock from selected SKU
    const currentStock = variantClickData?.productInfo?.selectedSkus?.quantity || stockQuantity || maxnumber;
    
    // Check if we can increment without exceeding stock
    if (qty < currentStock) {
      setQty(qty + 1);
    } else {
      notify(`Stoku i disponueshëm është ${currentStock}.`);
      setErrorMessage(`Stoku i disponueshëm është ${currentStock}.`);
      setErrorTrigger(prev => prev + 1);
    }
  };

  const onQuantityDecrement = () => {
    if (qty <= 1) return;
    setQty(qty - 1);
  };

  const selectedSizes = (e) => {
    const size = e.target.value;
    setSelectedSize(size);
    const filterSizes = variantClickData?.productInfo?.variantData?.sizes.filter(item => item.size === size);
    const skuData = filterSizes?.[0]?.skus?.[0];

    setVariantClickData((prev) => ({
      ...prev,
      productInfo: {
        ...prev.productInfo,
        selectedSize: filterSizes?.[0]?.size,
        selectedSkus: skuData,
      },
    }));
    setPrices(skuData);
    setStockQuantity(skuData?.quantity);
    setmaxnumber(skuData?.quantity);
    setQty(1);
  }

  const applyColorSelection = (colors, details = prodDetails) => {
    setSelectedColor(colors);
    const result = details?.variants?.find(item => item.colour.toLowerCase() === colors.toLowerCase());
    setVariantClickData({
      productInfo: {
        ...details,
        variantData: result,
      },
    });
    setSelectedSize("");
    setStockQuantity(0);
    setmaxnumber(1);
    setQty(1);
    setSkuData(null);

    const firstInStockSku = getFirstInStockSku(result);
    if (firstInStockSku) {
      setPrices(firstInStockSku);
    } else {
      // Still show price when colour has no stock
      setPrices(getFirstSku(result));
    }
  };

  const selectedColors = (colors) => {
    applyColorSelection(colors);
  };

  const addToCartData = (productInfo) => {

    // Multi-store product: store must be chosen first
    if (storeOptions.length > 1 && !selectedLocation) {
      notify("Ju lutemi zgjidhni dyqanin.");
      setErrorMessage("Ju lutemi zgjidhni dyqanin.");
      setErrorTrigger(prev => prev + 1);
      return false;
    }

    // Check if color and size are selected
    if (!selectedColor || !selectedSize) {
      notify("Ju lutemi zgjidhni ngjyrën dhe madhësinë e produktit.");
      setErrorMessage("Ju lutemi zgjidhni ngjyrën dhe madhësinë e produktit.");
      setErrorTrigger(prev => prev + 1);
      return false;
    }

    const productInfoData = productInfo?.productInfo;
    if (!productInfoData) {
      console.error("Invalid productInfo");
      return false;
    }

    // Get current SKU data for stock validation - prefer variantClickData as it's more reliable
    const skuData = variantClickData?.productInfo?.selectedSkus || prices;
    if (!skuData) {
      notify("Ju lutemi zgjidhni ngjyrën dhe madhësinë e produktit.");
      setErrorMessage("Ju lutemi zgjidhni ngjyrën dhe madhësinë e produktit.");
      setErrorTrigger(prev => prev + 1);
      return false;
    }
    
    // Additional check: ensure we have a valid SKU ID
    if (!skuData?.skuId) {
      notify("Ju lutemi zgjidhni ngjyrën dhe madhësinë e produktit.");
      setErrorMessage("Ju lutemi zgjidhni ngjyrën dhe madhësinë e produktit.");
      setErrorTrigger(prev => prev + 1);
      return false;
    }

    const availableStock = skuData?.quantity || 0;
    
    // Check if product is in stock
    if (availableStock < 1) {
      notify("Produkti nuk është në stok.");
      setErrorMessage("Produkti nuk është në stok.");
      setErrorTrigger(prev => prev + 1);
      return false;
    }

    const existingIndex = (Array.isArray(cartData) ? cartData : []).findIndex(
      (item) =>
        item.item_code === skuData?.skuId &&
        item.size === selectedSize &&
        String(item.location || "") === String(productInfoData?.location || "")
    );

    // create a new copy to avoid mutating redux state
    let newCart = Array.isArray(cartData) ? [...cartData] : [];

    if (existingIndex >= 0) {
      const existingItem = newCart[existingIndex];
      const newTotalQuantity = parseInt(existingItem.quantity) + parseInt(qty);
      
      // Check if adding quantity would exceed available stock
      if (newTotalQuantity > availableStock) {
        notify(`Stoku i disponueshëm është ${availableStock}. Ju keni ${existingItem.quantity} në shportë.`);
        setErrorMessage(`Stoku i disponueshëm është ${availableStock}. Ju keni ${existingItem.quantity} në shportë.`);
        setErrorTrigger(prev => prev + 1);
        return false;
      }
      
      const updatedItem = {
        ...existingItem,
        quantity: newTotalQuantity,
      };
      newCart = newCart.map((it, i) => (i === existingIndex ? updatedItem : it));
    } else {
      // Check if quantity exceeds available stock for new item
      if (parseInt(qty) > availableStock) {
        notify(`Stoku i disponueshëm është ${availableStock}.`);
        setErrorMessage(`Stoku i disponueshëm është ${availableStock}.`);
        setErrorTrigger(prev => prev + 1);
        return false;
      }

      const skuData = variantClickData?.productInfo?.selectedSkus;
      const variantData = variantClickData?.productInfo?.variantData;

      const ImageUrl = process.env.REACT_APP_IMAGE_URL + variantData?.newImagesUrl?.[0];
      const UniqueId = Math.floor(1000000000 + Math.random() * 9000000000);

      const newItem = {
        _id: productInfoData.externalId,
        brandEmail: storeInfo.email,
        email: productInfoData.email,
        name: prodDetails?.name,
        item_code: skuData?.skuId,
        description: prodDetails?.description,
        dimensions: productInfoData.dimensions,
        vendor: productInfoData.vendor,
        composition: productInfoData.composition,
        collectionn: productInfoData.collectionn,
        images: [ImageUrl],
        catId: productInfoData?.categories[0],
        vendorId: productInfoData.vendorId,
        brand: productInfoData.brand,
        changeFlag: productInfoData.changeFlag,
        color: productInfoData.color,
        countryOfOrigin: "",
        itemCategory: productInfoData?.categories[0],
        itemNo: "",
        itemSubCategory: "",
        published: "1",
        regular_price: skuData?.price || 0,
        sale_price: findPrice(skuData),
        season: prodDetails?.attributes?.Season,
        gender: prodDetails?.attributes?.Gender,
        size: selectedSize,
        startDate: productInfoData.startDate,
        stockQty: skuData?.quantity || 0,
        quantity: qty,
        location: productInfoData.location,
        storeName: storeInfo?.storeName || "",
        prodId: productInfoData._id,
        uniqueId: UniqueId,
        attributes: prodDetails?.attributes,
      };
      newCart = [...newCart, newItem];
    }

    // Clear error message on success
    setErrorMessage("");
    
    setCartPopup(true);
    setTimeout(() => setCartPopup(false), 5000);
    dispatch(addToCart(newCart, selectedSize));

    // Tracking (only fires after cookie consent is accepted)
    try {
      trackAddToCart({
        productId: productInfoData?.externalId,
        sku: skuData?.skuId,
        name: prodDetails?.name,
        category: productInfoData?.categories?.[0],
        price: findPrice(skuData),
        quantity: qty,
      });
    } catch (e) {
      // ignore tracking errors
    }

    setIsAlertVisible(true);
    toast.success('Porosia u shtua me sukses')
    setTimeout(() => setIsAlertVisible(false), 2000);
  };

  // Priority: discountPrice2 > discountPrice > price
  const pricedata = prices?.discountPrice2 > 0 ? prices?.discountPrice2 : 
                    prices?.discountPrice > 0 ? prices?.discountPrice : 
                    prices?.price;

  localStorage.setItem("mylocalid", id);

  let zoomImageData;
  if (selectedColor) {
    zoomImageData = variantClickData?.productInfo?.variantData?.newImagesUrl;
  } else {
    zoomImageData = prodDetails?.variants?.[0]?.newImagesUrl;
  }

  const storeSlug = storeInfo?.slug || storeOptions[0]?.storeInfo?.slug || "";
  const subBrand = subBrandFromProductBrand(prodDetails?.brand, storeSlug);
  const brandHref = storeSlug
    ? `/brands/${storeSlug}${subBrand ? `?brendi=${encodeURIComponent(subBrand)}` : ""}`
    : "/brands";


  return (
    <div>
      <div className="flex-col">
        {cartPopup ?
          <div className="sm:hidden shadow-lg z-50 bg-black  pt-1 pb-2 w-full fixed  flex flex-col text-white justify-center items-center space-y-2">
            <h1 className="font-bold text-sm">Produkti u shtua</h1>
            <Link to="/cart" className="bg-white text-sm text-black py-1 px-5 rounded-md">Shko tek shporta</Link>
          </div> : ""}

        <Header />

        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />

        <div className="container w-11/12 mx-auto p-3 mob-pt  produt-detail">
          <div className="flex space-x-20 w-full product-container mob-flex">

            {/* Product Image Section */}
            <div className="w-full flex mob-wid desktop-view">
              <div className="productthumb">
                <ProductImages zoomImageData={zoomImageData} />
              </div>
            </div>

            {/* Mobile View Section */}
            {displayWidth < 767 && (
              <div className="w-5/12 flex justify-center items-center mob-wid mobile-view">
                <ProductImages zoomImageData={zoomImageData} />
              </div>
            )}

            {/* Product Description Section */}
            <div className="flex-col w-7/12 mob-wid descc-mobile">
              <h1 className="text-4xl py-2 single-prod-title">
                {variantClickData.name || prodDetails?.name}
                <button onClick={() => addItemToWishlist(prodDetails)}>
                  <WishlistHeartIcon
                    size={24}
                    strokeWidth={1.6}
                    filled={false}
                    stroke="currentColor"
                    fill="none"
                  />
                </button>
              </h1>

              {/* <p className="text-md font-bold py-2 f-16 single-prod-price">
                {prices?.discountPrice > 0 ? (
                  <>
                    <del>{prices?.price}1 €</del>
                    <span className='regular salening'>{prices?.discountPrice} €</span>
                  </>
                ) : (
                  prices?.price > 0 && <h4 className="regular">{prices?.price?.toFixed(2)}€</h4>
                )}
              </p> */}

              {/* Showing price UI */}
              {PriceDisplay(prices)}



              {/* Gender and Brand Details */}
              {genderData !== "life" && (
                <div className="text-md font-semibold py-1 border-b  border-gray-300 prod-vend-det">
                  <p className='genderstyle_brendi'>
                    <span className="product-detail-label">Gjinia : </span>
                    <span className="font-normal">
                      {/* {genderData === "female" ? "Femër" : genderData === "male" ? "Mashkull" : "Fëmijë"} */}

                      {prodDetails?.attributes?.Gender?.toLowerCase() === "female"
                        ? "Femër"
                        : prodDetails?.attributes?.Gender?.toLowerCase() === "male"
                          ? "Mashkull"
                          : prodDetails?.attributes?.Gender}
                    </span>
                  </p>
                  <p className="genderstyle_brendi flex items-center gap-2">
                    <span className="product-detail-label">Brendi:</span>
                    <Link
                      to={brandHref}
                      className="brand-links text-blue-600 font-medium hover:underline hover:text-blue-800 transition-colors duration-200"
                    >
                      {prodDetails?.brand}
                    </Link>
                  </p>

                </div>
              )}

              {/* Store picker: only when same externalId exists in 2+ stores */}
              {storeOptions.length > 1 && (
                <div className="text-md font-semibold border-b border-dotted border-gray-300 flex space-x-4 items-start py-5">
                  <p className="product-detail-label whitespace-nowrap">Dyqani</p>
                  <div className="flex flex-wrap gap-2 items-center">
                    {storeOptions.map((opt) => {
                      const loc = opt?.productDetails?.location || opt?.location;
                      const label =
                        opt?.storeInfo?.storeName ||
                        opt?.storeInfo?.brand ||
                        "Dyqani";
                      const isSelected = String(selectedLocation) === String(loc);
                      return (
                        <button
                          key={String(loc)}
                          type="button"
                          onClick={() => applyStoreProduct(opt)}
                          className={`min-w-[6rem] px-3 py-2 rounded border text-xs font-medium transition-all
                            ${isSelected
                              ? "border-black bg-black text-white"
                              : "border-gray-300 bg-white text-gray-700 hover:border-gray-500 hover:bg-gray-50"
                            }`}
                        >
                          {label}
                        </button>
                      );
                    })}
                    {!selectedLocation && (
                      <span className="text-xs text-gray-400 w-full mt-1">Zgjidhni dyqanin fillimisht</span>
                    )}
                  </div>
                </div>
              )}

              <div className="text-md font-semibold border-b border-dotted border-gray-300 flex space-x-4 items-center py-5">
                <p className="product-detail-label">Ngjyra</p>
                <div className="flex object-cover cursor-pointer">

                  <div className="flex items-center gap-3 flex-wrap mt-2">
                    {storeOptions.length > 1 && !selectedLocation ? (
                      <span className="text-xs text-gray-400">Zgjidhni dyqanin fillimisht</span>
                    ) : (
                      allVariantData?.map(({ colour, colorHex }) => {
                      const isSelected = selectedColor === colour;
                      return (
                        <button
                          key={colour}
                          type="button"
                          onClick={() => selectedColors(colour)}
                          className={`relative w-8 h-8 rounded-full border-2 transition-all 
              ${isSelected ? "border-black scale-110" : "border-gray-300 hover:scale-105"}`}
                          style={{ backgroundColor: colorHex }}
                        >
                          {isSelected && (
                            <span className="absolute inset-0 flex items-center justify-center">
                              <i className="fa fa-check text-white text-xs"></i>
                            </span>
                          )}
                        </button>
                      );
                    })
                    )}
                  </div>
                </div>
              </div>

              {/* Size Selector - always visible like colour, shown as buttons with selected state */}
              <div className="text-md font-semibold border-b border-gray-300 flex space-x-4 items-center py-5">
                <p className="product-detail-label">Madhësia</p>
                <div className="flex flex-wrap gap-2 items-center">
                  {storeOptions.length > 1 && !selectedLocation ? (
                    <span className="text-xs text-gray-400">Zgjidhni dyqanin fillimisht</span>
                  ) : (
                    <>
                  {(variantClickData?.productInfo?.variantData?.sizes ?? prodDetails?.variants?.[0]?.sizes ?? []).map((res) => {
                    const size = res?.size;
                    const stockQty = res?.skus?.[0]?.quantity ?? 0;
                    const isSelected = selectedSize === size;
                    const isDisabled = !selectedColor || !stockQty;
                    return (
                      <button
                        key={size}
                        type="button"
                        disabled={isDisabled}
                        onClick={() => !isDisabled && selectedSizes({ target: { value: size } })}
                        className={`min-w-[1.75rem] px-2 py-1 rounded border text-xs font-medium transition-all
                          ${isSelected
                            ? "border-black bg-black text-white"
                            : isDisabled
                              ? "border-gray-200 bg-gray-100 text-gray-400 cursor-not-allowed"
                              : "border-gray-300 bg-white text-gray-700 hover:border-gray-500 hover:bg-gray-50"
                          }`}
                      >
                        <span className="block">{size}</span>
                        {!stockQty && selectedColor && <span className="block text-xs opacity-80">(Nuk ka stok)</span>}
                        {isSelected && <span className="block text-xs mt-0.5 font-normal opacity-90">Zgjedhur</span>}
                      </button>
                    );
                  })}
                  {!selectedColor && (
                    <span className="text-xs text-gray-400">Zgjidhni ngjyrën fillimisht</span>
                  )}
                    </>
                  )}
                </div>
              </div>

             

                {errorMessage && <ValidationError errorMessage={errorMessage}  trigger={errorTrigger}/>}


              {/* Quantity and Cart Buttons */}
              <div className="flex space-x-4 py-5 items-center">
                <div className="qty_sec_wrapper">
                  <label className="block text-sm font-medium text-gray-600 mb-2 tracking-wide">Sasia</label>
                  <div className='flex items-stretch'>
                    <div className="qty-sec inline-flex items-stretch border border-gray-300 rounded-md overflow-hidden bg-white shadow-sm">
                      <button
                        type="button"
                        aria-label="Ulër sasinë"
                        className="flex items-center justify-center w-10 h-10 text-gray-600 hover:bg-gray-100 hover:text-black border-r border-gray-200 transition-colors prod-qty"
                        onClick={onQuantityDecrement}
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <line x1="5" y1="12" x2="19" y2="12" />
                        </svg>
                      </button>
                      <input
                        type="text"
                        value={qty}
                        readOnly
                        aria-label="Sasia"
                        className="w-12 h-10 text-center text-sm font-medium text-gray-900 border-0 bg-transparent focus:ring-0 focus:outline-none mob-inp [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                      />
                      <button
                        type="button"
                        aria-label="Rrit sasinë"
                        className="flex items-center justify-center w-10 h-10 text-gray-600 hover:bg-gray-100 hover:text-black border-l border-gray-200 transition-colors prod-qty"
                        onClick={onQuantityIncrement}
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <line x1="12" y1="5" x2="12" y2="19" />
                          <line x1="5" y1="12" x2="19" y2="12" />
                        </svg>
                      </button>
                    </div>

                    <div className="add-cart-btns">
                      <button
                        className={`text-white w-36 py-3 flex justify-center items-center add_to_card_bt add_to_card_bt--black ${pricedata && stockQuantity > 0 ? "" : "bg-gray-400"}`}
                        style={{ backgroundColor: pricedata && stockQuantity > 0 ? "#000000" : "#9ca3af" }}
                        //disabled={!pricedata || stockQuantity < 1}
                        onClick={() => addToCartData(variantClickData || prodDetails?._id)}
                      >
                        <span className="px-2">{isAlertVisible ? "Produkti u shtua" : "Shto në shportë"}</span>
                      </button>

                      {(cartData?.length > 0 &&
                        <Link to={"/checkout"}>
                          <button
                            className="text-white w-20 py-3 flex justify-center items-center add_to_card_bt add_to_card_bt--black"
                            style={{ backgroundColor: "black" }}
                          >
                            <span className="px-2">Blej tani</span>
                          </button>
                        </Link>
                      )}
                    </div>


                    {/* <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:space-x-3 space-y-3 sm:space-y-0 w-full">
                      <button
                        className={`text-white flex-1 py-3 flex justify-center items-center add_to_card_bt ${pricedata && stockQuantity > 0 ? "" : "bg-gray-400 pointer-events-none"
                          }`}
                        style={{ backgroundColor: pricedata && stockQuantity > 0 ? "#fca700" : "gray" }}
                        disabled={!pricedata || stockQuantity < 1}
                        aria-disabled={!pricedata || stockQuantity < 1}
                        onClick={() => addToCartData(variantClickData || prodDetails?._id)}
                      >
                        <span className="px-2">{isAlertVisible ? "Produkti u shtua" : "Shto në shportë"}</span>
                      </button>

                      {cartData?.length > 0 && (
                        <Link to={"/checkout"} className="w-full sm:w-auto">
                          <button
                            className="text-white w-full sm:w-36 py-3 flex justify-center items-center add_to_card_bt"
                            style={{ backgroundColor: "#fca700" }}
                          >
                            <span className="px-2">Blej tani</span>
                          </button>
                        </Link>
                      )}
                    </div> */}



                  </div>
                </div>
              </div>

              <Summary prodDetails={prodDetails} />

            </div>
          </div>
        </div>
        <br />
      </div>
      {RelatePrd}
      <Footer />
    </div>
  )
}
